module.exports = __webpack_public_path__ + "img/archimed.f1c53714.png";